import { NUMSREGEX } from "@constants/regex";
import { getCardType } from "@utils/validators/card";

export const normalizeMonthAndYear = value => {
  let finalValue = "";
  let splitValue = value.split("/");
  let month = splitValue[0].replace(/[^\d]/g, "").trim();
  let year = splitValue[1] ? splitValue[1].replace(/[^\d]/g, "").trim() : "";
  year = year.slice(0, 2);

  if (value === "00") {
    return "0";
  }
  if (!year && value.includes("/") && value.endsWith("/")) {
    month = month.slice(0, 1);
  }

  let stringMonth = month.toString();

  if (stringMonth.length === 1) {
    if (month > 1) {
      month = `0${stringMonth}`;
    }
  }
  if (stringMonth.length > 2) {
    month = stringMonth.slice(0, 2);
    if (!year) {
      year = stringMonth.slice(2, 4);
    }
  }

  if (month > 12) {
    let numberArray = stringMonth.split("");
    month = `0${numberArray[0]}`;
    year = numberArray[2]
      ? `${numberArray[1]}${numberArray[2]}`
      : `${numberArray[1]}`;
  }

  if (year) {
    finalValue = `${month} / ${year}`;
  } else if (month.length >= 2) {
    finalValue = `${month} / `;
  } else {
    finalValue = month;
  }

  return finalValue;
};

const addSpace = val => {
  let refactoredString = val;
  if (!val[val.length - 1].trim()) {
    refactoredString = val;
  } else {
    refactoredString = `${val.slice(0, val.length - 1)} ${val[val.length - 1]}`;
  }

  return refactoredString;
};

export const normalizeCreditCardNumber = (keyCode, pasteData, value, prev) => {
  const creditCardType = getCardType(value);
  let returnValue = value;
  let valueArray = [];
  switch (creditCardType) {
    case "Visa":
    case "Mastercard":
    case "Visa Electron":
    case "Discover":
    case "JCB":
    case "Diners":
      valueArray = [5, 10, 15];
      break;
    case "AMEX":
    case "Diners - Carte Blanche":
      valueArray = [5, 12];
      break;
    default:
      break;
  }
  if (valueArray.includes(value.length)) {
    returnValue = addSpace(value);
  }
  if (keyCode === 8 && prev && value && !prev[prev.length - 1].trim()) {
    returnValue = returnValue.slice(0, returnValue.length - 1);
  }
  if (pasteData) {
    let newString = "";
    for (const element of pasteData) {
      newString = `${newString}${element}`;
      if (valueArray.includes(newString.length)) {
        newString = addSpace(newString);
      }
    }
    returnValue = newString;
  }
  return returnValue;
};

export const normalizeCvv = (creditCardValue, value) => {
  let maxLength = 4;
  if (creditCardValue) {
    const creditCardType = getCardType(creditCardValue);
    if (creditCardType === "AMEX") {
      maxLength = 4;
    } else {
      maxLength = 3;
    }
  }

  let returnValue = value.trim();
  const isNum = NUMSREGEX.test(returnValue);
  if (!isNum || returnValue.length > maxLength) {
    returnValue = returnValue.slice(0, returnValue.length - 1);
  }
  return returnValue;
};

export const formatPhone = num => {
  if (!num) {
    return num;
  }
  var numbers = num.replace(/\D/g, ""),
    char = { 0: "(", 3: ") ", 6: " - " };
  num = "";
  for (let i = 0; i < numbers.length; i++) {
    num += (char[i] || "") + numbers[i];
  }
  return num;
};
